import {spawnSync} from 'node:child_process';
import fs from 'node:fs';
import path from 'node:path';

import chalk from 'chalk';
import inquirer from 'inquirer';

export interface Template {
  name: string;
  repo: string;
}

export const downloadAndExtractTemplate = async (name: string, repo: string): Promise<string> => {
  const res = await fetch(repo);

  if (!res.ok) {
    throw new Error(chalk.red(`Failed to download: ${res.status} ${res.statusText}`));
  }

  const buffer = Buffer.from(await res.arrayBuffer());
  const tarPath = path.join(process.cwd(), `${name}.tar.gz`);

  fs.writeFileSync(tarPath, buffer);

  const extractPath = path.join(process.cwd(), name);

  if (!fs.existsSync(extractPath)) fs.mkdirSync(extractPath);

  const result = spawnSync('tar', ['-xzf', tarPath, '--strip-components=1', '-C', extractPath], {
    stdio: 'inherit'
  });

  if (result.error) throw result.error;

  fs.unlinkSync(tarPath);

  return extractPath;
};

/**
 * Prompt the user to select a template and download it
 */
export const chooseAndDownloadTemplate = async (
  templates: Template[]
): Promise<string | undefined> => {
  if (templates.length === 0) {
    process.stderr.write(chalk.red('No templates available\n'));

    return;
  }

  const {template} = await inquirer.prompt<{template: string}>([
    {
      choices: templates.map((t) => t.name),
      message: 'Select a template:',
      name: 'template',
      type: 'list'
    }
  ]);

  const selected = templates.find((t) => t.name === template);

  if (!selected) {
    process.stderr.write(chalk.red('Template not found!\n'));

    return;
  }

  try {
    return await downloadAndExtractTemplate(selected.name, selected.repo);
  } catch (err) {
    process.stderr.write(chalk.red((err as Error).message + '\n'));

    return undefined;
  }
};
